import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./HF.css";
import ABS from "../assets/1.png";
import { LuLogOut } from "react-icons/lu";

const Header = ({ isLoggedIn, setIsLoggedIn }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("userdetails");
    sessionStorage.setItem("manualLogout", "true");
    setIsLoggedIn(false);
    navigate("/");
  };

  // const handleLogout = () => {
  //   localStorage.removeItem("userdetails");
  //   setIsLoggedIn(false);

  //   // Use a short delay to allow ProtectedRoute to read manualLogout before redirect triggers
  //   setTimeout(() => {
  //     navigate("/");
  //   }, 50); // 50ms is enough
  // };

  useEffect(() => {
    if (location.pathname === "/") {
      localStorage.removeItem("userdetails");
      setIsLoggedIn(false);
    } else {
      const userDetails = JSON.parse(localStorage.getItem("userdetails"));
      if (userDetails?.empid) {
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    }
  }, [location.pathname]);

  return (
    <header className="header">
      <div className="container">
        {/* <div className="logo-container"> */}
        <img className="logo" src={ABS} alt="logo" />
        {/* </div> */}

        <nav>
          <ul className="nav-list">
            <li>
              {isLoggedIn ? (
                <button onClick={handleLogout} className="btton">
                  Logout{" "}
                  <div>
                    <LuLogOut />
                  </div>
                </button>
              ) : null}
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
